var map = {
	"./cert-E-commerce-cpttm.jpg": 269,
	"./cert-customer-cpttm.jpg": 270,
	"./cert-finance-cpttm.jpg": 272,
	"./cert-fsi-cpttm.jpg": 274,
	"./cert-general-staff-a-cpttm.jpg": 276,
	"./cert-general-staff-cpttm.jpg": 278,
	"./cert-general2024-cpttm.jpg": 208,
	"./cert-hr-cpttm.jpg": 279,
	"./cert-it-cpttm.jpg": 280,
	"./cert-market-cpttm.jpg": 281,
	"./cert-ngo-cpttm.jpg": 282,
	"./cert-senior-manager-cpttm.jpg": 284,
	"./cert-startup-cpttm.jpg": 285,
	"./cert-student-cpttm.jpg": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2668;